import React from "react";

interface AeroLoadingSpinnerProps {
    message?: string;
}

const AeroLoadingSpinner: React.FC<AeroLoadingSpinnerProps> = ({
    message = "Searching for flights...",
}) => {
    return (
        <div className="flex flex-col items-center justify-center py-20 gap-4">
            <div className="w-10 h-10 border-2 border-aero-gray/30 border-t-aero-orange rounded-full animate-spin" />
            <p className="text-aero-gray text-sm">{message}</p>
        </div>
    );
};

export default AeroLoadingSpinner;
